// removed by extract-text-webpack-plugin
module.exports = {"container":"_1A0xt_Qxk3IvClWc2NMD40","chip-cursor":"_1odWVaGzP2gZXD7xyht6oS","chipCursor":"_1odWVaGzP2gZXD7xyht6oS","bounce":"_3MeuyRAm7kXR1IZFrumKmu"};